module.exports = __webpack_public_path__ + "static/img/living_2.be56bbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/living_2.jpg
// module id = bcFy
// module chunks = 3